// Selectors and variables
var wsAddtocartForm = [
  "#shopify-section-product-template form[action$='/cart/add']",
  "form.product-purchase-form[action^='/cart/add']",  
  "form.shopify-product-form[action^='/nl/cart/add']",
  "form.shopify-product-form[action^='/fr/cart/add']",
  "form.shopify-product-form[action^='/de/cart/add']",
  "form.shopify-product-form[action^='/cart/add']",
  ".product-form form[action$='/cart/add.js']",
  ".product-form form[action$='/cart/add']"
].join(', ');


var addToWishlistCollection = '.cs_ws_icon';
var addToWishlistProduct = '#ws-fav-html';
var wsAddtocartBtn = "button[name='add'], input[name='add'], [name='add']";
var wsAddtocartBtnClass = "btn btn1 pr_btn btn--full btn--secondary w-full button button--primary button--filled button--large button--primary__filled _button--secondary _button--primary action_button button--full-width";
var wsBtnID = "ws-fav-html";
var wsBtnText = "Add to Wishlist";
var wsBtnTextWishlist = "In Wishlist";
var icon = window.wsapps.wishlist_icon;
var fillicon = window.wsapps.wishlist_icon_fill;
var latestCategories = '';
var ajaxcustomer_id = window.wsapps.customerId;
var ajaxcustomer_name = window.wsapps.customerName;
var ajaxcustomer_email = window.wsapps.customerEmailId;
var pageUrl = `/pages/${window.wsapps.pageURL}`;
if(window.wsapps.wishlist_status == '1') { 
  function setLoader() {
    //console.log('setLoader ======================================================');
    var CSWishlistPage = document.getElementsByClassName("CS-Wishlist-page");
    if(CSWishlistPage.length > 0){
      for (var i = 0; i < CSWishlistPage.length; i++) {
        CSWishlistPage[i].innerHTML = '<div class="EmptyPageData"><img src="https://cdn.shopify.com/s/files/1/0610/9642/7715/files/Web.gif?v=1709644593" /></div>';
      }
    }
  }
  function removeLoader() {
    //console.log('removeLoader ======================================================');
    $("#CS-Wishlist-page .EmptyPageData").remove();
  }
  // Get the current URL
  var currentURL = window.location.href;
  function wishlistHTML(data){
    //console.log('wishlistHTML ======================================================');
    var wishlistHTML = document.getElementsByClassName('CS-Wishlist-page');
    if(wishlistHTML.length > 0){
      for (var i = 0; i < wishlistHTML.length; i++) {        
        wishlistHTML[i].innerHTML = '';  
        wishlistHTML[i].innerHTML += data;
      }
    }
  }
  
  function getUrlParameter(name) {
    // console.log('getUrlParameter ======================================================');
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(currentURL);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }    
  
  // Extract values for from_user_id and list_id
  var fromUserId = getUrlParameter('from_user_id');
  var listId = getUrlParameter('list_id');
  
  function CSCategoryGetSingle(catId) {
    //console.log('CSCategoryGetSingle ====================================================== API');
    // mdvWishFlat-1: one wishlist per customer. A list link (?from_user_id=&list_id=) renders the owner's
    // whole wishlist - every list, newest first, one card per product - not one list (catId is ignored).
    var mdvOwner = fromUserId ? fromUserId : ajaxcustomer_id;
    var mdvOwn = String(mdvOwner) === String(ajaxcustomer_id);
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = mdvOwner;
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;

    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      if (result && typeof result.data === 'object' && result.data !== null && Array.isArray(result.data.categories)) {
        if (mdvOwn) { mdvWishRemember(mdvOwner, result.data.categories); }
        var mdvFlat = mdvWishFlatten(result.data.categories, mdvOwn ? null : {});
        var productList = mdvFlat.products.slice();
        productList["title"] = '';
        if(productList.length > 0){
          CSRetrieveWsDataCategoryShow(productList, 'drawer', mdvFlat.category ? mdvFlat.category.id : catId)
          if(listId){
            //console.log('15 =================');
            CSRetrieveWishlistData('drawer');
          }
        }else{
          window.location.href = "/pages/"+window.wsapps.pageURL;
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
  
  /* Wishlist Retrieve Wishlist Data */      
  function CSRetrieveWsDataCategory(catId) {  
    //console.log('CSRetrieveWsDataCategory ======================================================  API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = fromUserId ? fromUserId : ajaxcustomer_id;   

    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    
    fetch(url)
    .then(response => {        
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {      
      // Check if result.data exists and is an object
      if (result && typeof result.data === 'object' && result.data !== null && Array.isArray(result.data.categories)) {        
        // mdvWishFlat-1: a list link shows the owner's whole wishlist (every list, newest first), not list_id.
        var mdvOwnList = String(wsGetWishlist.customer_id) === String(ajaxcustomer_id);
        if (mdvOwnList) { mdvWishRemember(wsGetWishlist.customer_id, result.data.categories); }
        var productList = mdvWishFlatten(result.data.categories, mdvOwnList ? null : {}).products.slice();
        productList["title"] = '';
        if(listId){
          if(productList.length > 0){            
            CSRetrieveWsDataCategoryShow(productList)
          }else{
            window.location.href = "/pages/"+window.wsapps.pageURL;
          }
        }      
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
  // Category Header
  function CScategoryHeader(key){    
    //console.log('CScategoryHeader ======================================================');
    var CScategoryHeader = `<div class="cs-list-header-title"><h4>${key.toLowerCase()}</h4></div>`;      
    return CScategoryHeader
  }

  
  // Particular category in detail
  async function CSRetrieveWsDataCategoryShow(productList, drawer, catId) { 
    //console.log('CSRetrieveWsDataCategoryShow ======================================================');
    var htmlNew = `<div class="button_back"><a href="/pages/${window.wsapps.pageURL}"></a><div class="productListtitle">${productList.title.toLowerCase()}</div></div><div class="productHandlesByCategory productHandlesByCategory-134 productHandlesByCategory-${catId} category-id-${productList.title.toLowerCase()}" data-name="${productList.title.toLowerCase()}" id="category-id-Seci" data-cat-id="${catId}">`;
    htmlNew += `<div class="category-list-wrapper"><div class="category-list ${window.wsapps.parentClass}">`;
    productList.slice().forEach(product => {
      // mdvWishIds-1: the card star also carries class mdv-ws-fav-btn (id ws-fav-btn unchanged)
      htmlNew += `
      <div class="111 = cross-sell-product-item-drawer cross-sell-product-item cross-sell-item main-product-item two_column_item" data-handle="${product.handle}" data-id="${product.variants.shopify_variant_id}">
       <div class="cross-sell-product-image">
          <a href="/products/${product.handle}">
            <img src="${product.image_url}" alt="${product.title}" loading="lazy">
          </a>
       </div>
       <div class="cross-sell-product-content">
          <div class="cross-sell-product-price">
             <div class="cs-product-title">
                <a href="/products/${product.handle}">${product.title}</a>
             </div>
             <div class="cs_ws_icon" data-id="${product.shopify_product_id}" data-handle="${product.handle}" data-varid="${product.variants.shopify_variant_id}">
                <button aria-label="Add to Wishlist" id="ws-fav-btn" type="button" class="action_button  ws-active mdv-ws-fav-btn">
                   <span class="cs-wishlist-icon">
                      <svg width="25" height="21" viewBox="0 0 23 21" fill="none" xmlns="https://www.w3.org/2000/svg">
                         <path d="M11.5801 0.992188L14.668 7.2511L21.5801 8.2606L16.5801 13.13L17.7678 20.0183L11.5801 16.7642L5.39243 20.0183L6.58008 13.13L1.58008 8.2606L8.49219 7.2511L11.5801 0.992188Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                   </span>
                </button>
             </div>
          </div>          
       </div>
    </div>`;      
    })
    
    htmlNew += '</div></div></div>';    
    if(drawer){
      var wishlistHTML1 = document.querySelectorAll('.main-wrapper .CS-Wishlist-page'); 
      wishlistHTML1.forEach(function(element) {
        element.innerHTML = '';  
        element.innerHTML += htmlNew; 
      });
    }else{
      wishlistHTML(htmlNew)
    }
    if(location.pathname.includes('/collections/')){ 
      wishlistBtnCollection(productList);
    }
    formData();
  }

  
  function CSRetrieveWishlistProData() {
    //console.log('CSRetrieveWishlistProData ====================================================== API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = window.wsapps.customerId;
    wsGetWishlist.product_id = window.wsapps.product_id;
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlists-by-product?${params1.toString()}`;  
    return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      // console.log('result ===', result);
      // console.log('result ===', result.data.isWishlistHasProduct);
      var csWsIconPro = document.querySelector(addToWishlistProduct);
      let spanbutton = csWsIconPro && csWsIconPro.querySelector('button');
      if(csWsIconPro && result && result.data && result.data.isWishlistHasProduct){
        if (Array.isArray(result.data.categoryIds) && result.data.categoryIds.length) {
          csWsIconPro.setAttribute('data-categoryId', result.data.categoryIds[0]);
        }  
        csWsIconPro.setAttribute('data-varId-dddd', 'window.wsapps.variant_id');
        csWsIconPro.setAttribute('data-varId', window.wsapps.variant_id);
        csWsIconPro.setAttribute('data-handle', window.wsapps.product_handle);
        //csWsIconPro.setAttribute('data-categoryId', matchedProduct.cid);   
        if (spanbutton) {
          spanbutton.classList.add('ws-active');
        }
        let span = csWsIconPro.querySelector('span');
        if (span) {
          span.innerHTML = fillicon;
        }
      }else{
        if (csWsIconPro) {
          csWsIconPro.classList.remove('ws-active');
          csWsIconPro.removeAttribute('data-categoryId');
        }
        wishlistBtnPDP();
      }  
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .then(() => {
      return CSRetrieveWishlistData('drawer');
    });
  }

  

  
  /* Wishlist Retrieve Wishlist Data */      
  function CSRetrieveWishlistData(drawer, customer_id) { 
    //console.log('CSRetrieveWishlistData ====================================================== Main function Disha  API');
    if (!mdvWishKeepVisible) { $('div.productHandlesByCategory').hide() } // mdvWishGrid-1 W7
    // $('.cs-wishlist-wrapper').html('')
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = customer_id ? customer_id : ajaxcustomer_id;
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {
      $('div.productHandlesByCategory').show()
      if (result && typeof result.data === 'object' && result.data !== null && Array.isArray(result.data.categories)) {
        var mainArray = result.data.categories;
        mdvWishRemember(wsGetWishlist.customer_id, mainArray); // mdvWishFlat-1: last snapshot of the signed-in customer
        if (Array.isArray(mainArray) && mainArray.length > 0) {
          latestCategories = mdvWishDefaultId(mainArray); // mdvWishFlat-1: the default list is the lowest id (was the last list)
        }
        var productList = []
        for (const obj of mainArray) {          
          for (var product of obj.products) {
            product["cid"] = obj.id;
            productList.push(product)
          }
        } 
        if(drawer){
          CSWishlistDrawerData(result, productList);  
        }else{
          if(location.pathname.includes('/collections/')){            
            wishlistBtnCollection(productList);      
          }
          if(location.pathname.includes('/products/')){ 
            wishlistBtnPDP(productList);
          }
          if($('.main-wrapper .CS-Wishlist-page').length > 0){
            if(!listId){              
              CSWishlistPageData(result, productList);
              CSWishlistDrawerData(result, productList);  
            }else{              
              CSCategoryGetSingle(listId);
              CSWishlistDrawerData(result, productList);  
            }
          }
        }
        if(mainArray.length === 0){
          var productHandles = document.querySelector('.productHandlesByCategory[data-name="newCategory"]');      
          if (productHandles) {
              productHandles.style.display = 'none';
          }
        }
        //Get page data End        
      } else {
        if(location.pathname.includes('/products/')){ 
          wishlistBtnPDP();
        }
        wishlistBtnCollection();
        emptyPage();
        var wishlistHTML = document.querySelectorAll('.main-wrapper .CS-Wishlist-page');
        if(wishlistHTML.length > 0){
          for (var i = 0; i < wishlistHTML.length; i++) {
            wishlistHTML[i].classList.add("wishlist-overflow");
          }
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
 
  var mdvWishTabRendersDrawer = false; // mdvWishGrid-1: true where the .cart_tab_link2 click re-renders the drawer
  var mdvWishKeepVisible = false; // mdvWishGrid-1 W7: skip the hide-all-lists step for post-tap reconciles
  var mdvWishSnap = null; // mdvWishFlat-1: last get-wishlist snapshot of the signed-in customer {customer, categories}
  var mdvWishCreating = null; // mdvWishFlat-1: in-flight FAVOURITE creation {customer, promise}, at most one per page
  var mdvWishPinsMem = {}; // mdvWishFlat-1: pin map used when localStorage is unavailable

  if(fromUserId){    
    CSCategoryGetSingle(listId)   
    if(location.pathname.includes('/collections/')){
      //console.log('2 =================');
      CSRetrieveWishlistData('drawer');
    }
  }else if(ajaxcustomer_id){     
    if(location.pathname.includes(pageUrl)){
      //console.log('3 =================');
      CSRetrieveWishlistData();
    } else if(location.pathname.includes('/collections/') && location.pathname.includes('/products/') || location.pathname.includes('/products/')){
       CSRetrieveWishlistProData()     
      //CSRetrieveWishlistData('drawer');    
    } else if(location.pathname.includes('/collections/')){   
      //console.log('4 =================');
      CSRetrieveWishlistData('drawer');    
    } else{
       mdvWishTabRendersDrawer = true;
       $('.cart_tab_link2').click(function(){
        //console.log('5 =================');
        CSRetrieveWishlistData('drawer');
      })
    }
    
  }else{    
    if(location.pathname.includes('/products/')){ 
      wishlistBtnPDP()
    }
    if(location.pathname.includes('/collections/')){ 
      wishlistBtnCollection()
    }
    emptyPage();
  }

  function emptyPage() {    
    //console.log('emptyPage ======================================================');
    var data = CSWSPageDataHeader();   
    data += emptyhtmlGrid();
    wishlistHTML(data);
    var elements = document.querySelectorAll('button#csws-create-list');
    for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
    }
  }
  /* Fetch Wishlist data on button click */
  function CSUpdateUI(target, PDPButton, newCreate) { 
    //console.log('CSUpdateUI ======================================================  API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = ajaxcustomer_id;   
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    fetch(url)
    .then(response => {        
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(result => {    
      var mainArray = result.data.categories;        
      var productList = []
      for (const obj of mainArray) {          
        for (var product of obj.products) {
          product["cid"] = obj.id;
          productList.push(product);
        }
      }
      var CSWishlistPage = document.getElementsByClassName("CS-Wishlist-page");
      if(CSWishlistPage && listId && fromUserId){   
        CSRetrieveWsDataCategory();             
      }else if(CSWishlistPage && newCreate){
        CSWishlistPageData(result, productList);
        CSWishlistDrawerData(result, productList);
      }else{
        if(PDPButton){
          var active = typeof productList != 'undefined' && productList != null ? productList.find(item => item.handle === window.wsapps.product_handle) : active;          
          if (active) {            
            target.setAttribute('aria-label', wsBtnTextWishlist);
            target.closest('#'+wsBtnID).setAttribute('data-categoryId', active.cid);
            target.className = 'ws-active '+wsAddtocartBtnClass;
            target.querySelector('.cs-wishlist-text').textContent = wsBtnTextWishlist;
            target.querySelector('.cs-wishlist-icon').innerHTML = fillicon;
          }else{
            target.setAttribute('aria-label', wsBtnText);
            target.closest('#'+wsBtnID).setAttribute('data-categoryId', '');
            target.classList.remove('ws-active');
            target.querySelector('.cs-wishlist-text').textContent = wsBtnText;
            target.querySelector('.cs-wishlist-icon').innerHTML = icon;
          }
        }else{
          var dataHandle = target.closest(addToWishlistCollection).getAttribute('data-handle');   
          var active = typeof productList != 'undefined' && productList != null ? productList.find(item => item.handle === dataHandle) : active;            
          if(active){ 
            target.closest(addToWishlistCollection).setAttribute('data-categoryId', active.cid);        
            target.setAttribute('aria-label', wsBtnTextWishlist);                
            target.classList.add('ws-active');
            target.querySelector('span').innerHTML = fillicon;
          }else{
            target.setAttribute('aria-label', wsBtnText);                
            target.classList.remove('ws-active');
            target.querySelector('span').innerHTML = icon;
          }
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });    
  }
  
  /* Add Wishlist btn on Collection page */
  function wishlistBtnCollection(productData){  
    //console.log('wishlistBtnCollection ======================================================');
    var csWsIcon = document.querySelectorAll(addToWishlistCollection);
    csWsIcon.forEach(function(element) {
      let buttonInner = element.querySelector('button');
      let span = element.querySelector('span');
      var dataHandle = element.getAttribute('data-handle');
      var matchedProduct = Array.isArray(productData)
        ? productData.find(item => item.handle === dataHandle)
        : null;
      
      if (matchedProduct) {
        element.setAttribute('data-categoryId', matchedProduct.cid);
        element.setAttribute('aria-label', wsBtnTextWishlist);
        if (buttonInner) {
          buttonInner.classList.add('ws-active', 'action_button', 'DishaMavani');
        }        
        if (span) {
          span.innerHTML = fillicon;
        }
      } else {
        if (buttonInner) {
          buttonInner.classList.remove('ws-active', 'action_button', 'DishaMavani');
        }
        if (span) {
          span.innerHTML = icon;
        }
      }
    });    
  }

  /* Add Wishlist btn on PDP page */
  function wishlistBtnPDP(productData) {
    // console.log('wishlistBtnPDP ======================================================');    
    var csWsIconPro = document.querySelectorAll(addToWishlistProduct);
    csWsIconPro.forEach(function(element) {
      let span = element.querySelector('span');
      let spanbutton = element.querySelector('button');
      var matchedProduct = Array.isArray(productData)
        ? productData.find(item => item.handle === window.wsapps.product_handle)
        : null;
      if (matchedProduct) {
        element.setAttribute('data-varId', window.wsapps.variant_id);
        element.setAttribute('data-handle', window.wsapps.product_handle);
        element.setAttribute('data-categoryId', matchedProduct.cid);        
        if (spanbutton) {
          spanbutton.classList.add('ws-active');
        }
        if (span) {
          span.innerHTML = fillicon;
        }
      } else {
        if (spanbutton) {
          spanbutton.classList.remove('ws-active');
        }
        if (span) {
          span.innerHTML = icon;
        }
      }
    });
  }
  async function categoryGetList(target, productHandle, data_id, variant_id, category_id, customer_id, customer_name, customer_email) {
    //console.log('categoryGetList ======================================================  API');
    // mdvWishFlat-1: one wishlist per customer - no list chooser. A tap on an empty star adds straight to the
    // default list (btnClick resolves it); a tap on a filled star removes the product from every list.
    var button = target.querySelector('#ws-fav-btn');
    if (button.classList.contains('ws-active')) {
        btnClick(target, productHandle, data_id, variant_id, category_id)
    } else {
        var mdvDrawerPage = document.querySelector('.cart_tab2 #CS-Wishlist-page');
        if (mdvDrawerPage) { mdvDrawerPage.style.display = 'flex'; }
        btnClick(target, productHandle, data_id, variant_id, category_id, null, customer_id, customer_name, customer_email)
    }
  }


  async function btnClick(target, productHandle, data_id, variant_id, category_id, remove, customer_id, customer_name, customer_email) {  
    //console.log('btnClick ====================================================== API');    
    var button = target.querySelector('#ws-fav-btn');
    if (button.classList.contains('ws-active')) {
        // mdvWishFlat-1: one wishlist per customer - remove the product from EVERY list that holds it: one
        // DELETE per list id in the last snapshot (re-read once if the product is not in it), all settled.
        // A DELETE is never sent without a numeric list id. Any failure -> W5 below restores server truth.
        var mdvRmProduct = data_id ? data_id : window.wsapps.product_id;
        var mdvRemoveOk = false; // mdvWishGrid-1 W5
        var mdvRmResults = [];
        try {
            var mdvRmLists = await mdvWishListsHolding(mdvRmProduct, customer_id ? customer_id : ajaxcustomer_id);
            var mdvRmSettled = await Promise.allSettled(mdvRmLists.map(function(mdvRmList) {
                var wsRemove = {};
                wsRemove.store_name = window.wsapps.store_name;
                wsRemove.product_id = mdvRmProduct;
                wsRemove.category_id = mdvRmList;
                var requestOptions = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(wsRemove)
                };
                //console.log('wsRemove ===', wsRemove);
                return fetch('https://wishlistapp.manieredevoir.com/api/remove-from-wishlist', requestOptions)
                    .then(function(response) {
                        if (!response.ok) {
                            throw new Error('Network response was not ok.');
                        }
                        return response.json();
                    });
            }));
            mdvRmResults = mdvRmSettled.map(function(s) { return s.status === 'fulfilled' ? s.value : s.reason; });
            mdvRemoveOk = mdvRmSettled.every(function(s) { return s.status === 'fulfilled'; });
        } catch (error) {
            mdvRmResults = [error];
        }
        if (mdvRemoveOk) { mdvWishForget(mdvRmProduct); } else { mdvWishSnap = null; }
        Promise.resolve(mdvRmResults)
            .then(function(result) {
                if (!mdvRemoveOk) { throw new Error('mdvWishFlat-1: the remove failed in at least one list'); }
                console.log("result ===", result);
                if(productHandle){            
                    if(remove){
                        if(listId){
                            let items = $('.page-width #CS-Wishlist-page .cross-sell-product-item').not('.delete_hide');                            
                            if(items.length == 0){                      
                                CSCategoryGetSingle(category_id)
                            }
                            if(document.querySelector('.min-cart').classList.contains('active') && fromUserId){                                
                              CSCategoryGetSingle(category_id);
                            }else{
                              //console.log('6 =================');
                              CSRetrieveWishlistData('drawer');
                            }
                        }else{
                            let cartTabLengths = [];
                            let pageWidthLengths = [];
                            $('.cart_tab2 .productHandlesByCategory').each(function() {
                                let items = $(this).find('.ws-pro-list-image').not('.delete_hide').not('.category_id');              
                                cartTabLengths.push(items.length);
                                if(items.length == 0){ 
                                    $(this).addClass('is-empty');
                                }
                            });
                            
                            if(!fromUserId){
                              $('.page-width .productHandlesByCategory').each(function() {
                                  let items = $(this).find('.ws-pro-list-image').not('.delete_hide').not('.category_id');                                
                                  pageWidthLengths.push(items.length); // Store the length in the array
                                  if (items.length == 0) { 
                                      $(this).addClass('is-empty');
                                      $(this).find('.view_all_link').hide();
                                  }
                              });                              
                              // Compare the lengths after both loops                            
                              for (let i = 0; i < cartTabLengths.length; i++) {
                                  if (cartTabLengths[i] !== pageWidthLengths[i]) {
                                      if(pageWidthLengths[i] == 0 && cartTabLengths[i] > pageWidthLengths[i]){  
                                        //console.log('7 =================');
                                        CSRetrieveWishlistData();                                      
                                      }                                   
                                  }
                              }
                            }
                                                        
                            if(location.pathname.includes(pageUrl) && document.querySelector('.min-cart').classList.contains('active')){
                              //console.log('8 =================');
                              CSRetrieveWishlistData();
                            }else if(location.pathname.includes(pageUrl)){
                              //console.log('9 =================');
                              CSRetrieveWishlistData('drawer');
                            }  
                        }                        
                        if((!document.querySelector('.min-cart').classList.contains('active') && location.pathname.includes('/collections/')) || 
                          (!document.querySelector('.min-cart').classList.contains('active') && location.pathname.includes('/products/'))){
                          //console.log('10 =================');
                          CSRetrieveWishlistData('drawer');
                        }
                    }else{
                        setLoader();
                        CSUpdateUI(button)  
                    }
                }else{              
                    CSUpdateUI(button, 'buttonPDP')
                }
            })
            .catch(function(error) {
                console.log('error', error);
                // mdvWishGrid-1 W5: the remove failed, so restore server truth and the star.
                if (!mdvRemoveOk) {
                    if (button) {
                        button.classList.add('ws-active');
                        var mdvRmIcon = button.querySelector('.cs-wishlist-icon');
                        if (mdvRmIcon) { mdvRmIcon.innerHTML = fillicon; }
                    }
                    mdvWishKeepVisible = true;
                    try {
                        CSRetrieveWishlistData(location.pathname.includes(pageUrl) ? undefined : 'drawer');
                    } finally {
                        mdvWishKeepVisible = false;
                    }
                }
            });            
    } else {        
        var wsAdd = {};
        wsAdd.store_name = window.wsapps.store_name;      
        wsAdd.customer_id = customer_id ? customer_id : ajaxcustomer_id;
        wsAdd.customer_email = customer_email ? customer_email : ajaxcustomer_email;
        wsAdd.customer_name = customer_name ? customer_name : ajaxcustomer_name ? ajaxcustomer_name : ajaxcustomer_email;
        //console.log('wsAdd btnClick ===', wsAdd)
        // mdvWishFlat-1: every add goes to the customer's default list (lowest list id), never to the clicked
        // or the last list; with no list yet, a FAVOURITE list is created first (mdvWishAddTarget).
        wsAdd.product_id = data_id ? data_id : window.wsapps.product_id;
        wsAdd.variant_id = variant_id ? variant_id : window.wsapps.variant_id;
        // mdvWishGrid-1 W4: optimistic star + placeholder card BEFORE the POST.
        var mdvBtn = target.querySelector('#ws-fav-btn');
        var mdvIcon = target.querySelector('.cs-wishlist-icon');
        if (mdvBtn) { mdvBtn.classList.add('ws-active'); }
        if (mdvIcon) { mdvIcon.innerHTML = fillicon; }
        mdvWishPin(wsAdd.product_id); // mdvWishFlat-1: this device's add is shown first (newest-first pin)
        var mdvPending = mdvWishPlaceholder(target, mdvWishDefaultId(mdvWishSnapFor(wsAdd.customer_id)), wsAdd.product_id, productHandle);
        try {
            var mdvAddList = await mdvWishAddTarget(wsAdd.customer_id, wsAdd.customer_name, wsAdd.customer_email);
            if (mdvAddList) { wsAdd.category_id = mdvAddList; }
            var requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(wsAdd)
            };
            const response = await fetch('https://wishlistapp.manieredevoir.com/api/add-to-wishlist', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const result = await response.json();
        } catch (error) {
            console.log('error', error);
            mdvWishUnpin(wsAdd.product_id); // mdvWishFlat-1
            mdvWishSnap = null; // mdvWishFlat-1: re-read the wishlist before the next tap
            // mdvWishGrid-1 W4: failure -> drop the placeholder, restore the star, no re-render.
            mdvWishDropPlaceholder(mdvPending);
            if (mdvBtn) { mdvBtn.classList.remove('ws-active'); }
            if (mdvIcon) { mdvIcon.innerHTML = icon; }
            return;
        }
        try {
            if(category_id){
                $('.cart_tab2 #CS-Wishlist-page').removeClass('selectCategory');
            }
            // W7: '.header .cart a' is the drawer-open trigger (sections/header.liquid), so it stays.
            // W2: the manual append is gone; one full re-render is the only render path. The
            // '.cart_tab_link2' handler re-renders only where it is bound (mdvWishTabRendersDrawer);
            // on product/collection/wishlist pages render here instead, exactly once. The lists stay
            // visible (placeholder included) until the re-render swaps the wrapper.
            mdvWishKeepVisible = true;
            try {
                $('.header .cart a, .cart_tab_link2').trigger('click');
                if (!mdvWishTabRendersDrawer) {
                    CSRetrieveWishlistData('drawer');
                }
            } finally {
                mdvWishKeepVisible = false;
            }
        } catch (error) {
            console.log('error', error);
        }
    }
  }
  
  async function getproHTML(file) {
    try {
      const response = await fetch(file);
      if (!response.ok) {
        // If response is not OK (like 404), return null
        console.warn(`Fetch failed for ${file} — Status: ${response.status}`);
        return null;
      }
      return await response.text();
    } catch (error) {
      console.error(`Fetch error for ${file}:`, error);
      return null;
    }
  }

  // mdvWishGrid-1 W4/W5/W6 helpers. Optimistic DOM only lives until the next full render
  // (CSRetrieveWishlistData replaces the drawer wrapper); no local state is persisted.
  function mdvWishImageSrc(target) {
    var pick = function (img) {
      return img ? (img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '') : '';
    };
    var notIcon = function (img) { return !(img.closest && img.closest('.cs-wishlist-icon, #ws-fav-btn')); };
    var src = '';
    if (target && target.id === wsBtnID) {
      var gallery = document.querySelectorAll('.product-page--images-container img, .product-page-mobile--images-container img');
      for (var i = 0; i < gallery.length && !src; i++) {
        if (notIcon(gallery[i])) { src = pick(gallery[i]); }
      }
      if (!src) {
        var og = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]');
        src = og ? (og.getAttribute('content') || '') : '';
      }
    } else {
      for (var el = target ? target.parentElement : null, d = 0; el && el !== document.body && d < 8 && !src; el = el.parentElement, d++) {
        var imgs = el.querySelectorAll('img');
        for (var j = 0; j < imgs.length && !src; j++) {
          if (notIcon(imgs[j])) { src = pick(imgs[j]); }
        }
      }
    }
    return src.indexOf('data:') === 0 ? '' : src;
  }

  function mdvWishPlaceholder(target, categoryId, productId, productHandle) {
    try {
      var row = categoryId ? document.querySelector('.cart_tab2 .productHandlesByCategory-' + categoryId + ' .scroll_product_drawer') : null;
      if (!row) {
        row = document.querySelector('.cart_tab2 .productHandlesByCategory[data-name="FAVOURITE"] .scroll_product_drawer');
      }
      if (!row) { // mdvWishFlat-1: the drawer has a single list block
        row = document.querySelector('.cart_tab2 .productHandlesByCategory .scroll_product_drawer');
      }
      if (!row) { return null; }
      var card = document.createElement('div');
      card.className = 'ws-pro-list-image';
      card.setAttribute('data-mdv-optimistic', '1');
      card.setAttribute('data-id', String(productId || ''));
      var imageWrap = document.createElement('div');
      imageWrap.className = 'cross-sell-product-image';
      var link = document.createElement('a');
      if (productHandle) { link.setAttribute('href', '/products/' + productHandle); }
      var src = mdvWishImageSrc(target);
      if (src) {
        var img = document.createElement('img');
        img.setAttribute('src', src);
        img.setAttribute('alt', '');
        link.appendChild(img);
      }
      imageWrap.appendChild(link);
      card.appendChild(imageWrap);
      var first = row.firstElementChild;
      if (first && first.classList.contains('category_id')) {
        first.insertAdjacentElement('afterend', card);
      } else {
        row.insertBefore(card, row.firstChild);
      }
      var group = row.closest('.productHandlesByCategory');
      var wasEmpty = !!(group && group.classList.contains('is-empty'));
      if (wasEmpty) { group.classList.remove('is-empty'); }
      return { card: card, group: group, wasEmpty: wasEmpty };
    } catch (err) {
      return null;
    }
  }

  function mdvWishDropPlaceholder(pending) {
    if (!pending || !pending.card) { return; }
    if (pending.card.parentNode) { pending.card.parentNode.removeChild(pending.card); }
    if (pending.wasEmpty && pending.group && pending.group.isConnected) { pending.group.classList.add('is-empty'); }
  }

  // W6: true when this product was already rendered in this list (dedupes duplicate server rows).
  function mdvWishSeen(seen, product) {
    var key = product ? product.shopify_product_id : null;
    if (key === undefined || key === null || key === '') { return false; }
    key = String(key);
    if (seen[key]) { return true; }
    seen[key] = 1;
    return false;
  }

  // mdvWishFlat-1: one wishlist per customer (UI-only flatten; the server keeps its lists and memberships).
  //  - snapshot: the last get-wishlist categories read for the signed-in customer (mdvWishSnap);
  //  - default list: the customer's list with the numerically lowest id (normally the original FAVOURITE);
  //  - display (mdvWishFlatten, a pure function of snapshot + pins): this device's own adds first, newest
  //    first (localStorage 'mdvWishAdded' {productId: ms}, pruned to the snapshot); then every list by
  //    descending list id, each newest first; one card per product (the first occurrence wins).
  function mdvWishIsId(id) {
    return (typeof id === 'number' || typeof id === 'string') && /^[1-9][0-9]{0,19}$/.test(String(id));
  }

  function mdvWishIdCmp(a, b) { // numeric order of two decimal ids, compared as strings (safe past 2^53)
    a = String(a); b = String(b);
    if (a.length !== b.length) { return a.length < b.length ? -1 : 1; }
    return a < b ? -1 : (a > b ? 1 : 0);
  }

  function mdvWishDefaultId(categories) {
    var best = null;
    (Array.isArray(categories) ? categories : []).forEach(function (c) {
      if (c && mdvWishIsId(c.id) && (best === null || mdvWishIdCmp(c.id, best) < 0)) { best = c.id; }
    });
    return best;
  }

  function mdvWishFlatten(categories, pins) {
    var lists = (Array.isArray(categories) ? categories : []).filter(function (c) { return c && Array.isArray(c.products); });
    var defaultId = mdvWishDefaultId(lists);
    var category = null;
    lists.forEach(function (c) { if (category === null && defaultId !== null && String(c.id) === String(defaultId)) { category = c; } });
    var seen = {}, products = [];
    lists.slice().sort(function (a, b) { return mdvWishIdCmp(b.id, a.id); }).forEach(function (c) {
      c.products.slice().reverse().forEach(function (p) {
        if (!p || mdvWishSeen(seen, p)) { return; }
        if (p.cid === undefined) { p.cid = c.id; }
        products.push(p);
      });
    });
    pins = pins || mdvWishPins();
    var pinOf = function (p) { var v = Number(pins[String(p.shopify_product_id)]); return isFinite(v) && v > 0 ? v : 0; };
    var pinned = products.filter(function (p) { return pinOf(p) > 0; });
    pinned.sort(function (a, b) { return pinOf(b) - pinOf(a); });
    return { category: category, products: pinned.concat(products.filter(function (p) { return pinOf(p) === 0; })) };
  }

  function mdvWishPins() {
    try {
      var raw = window.localStorage.getItem('mdvWishAdded');
      var map = raw ? JSON.parse(raw) : {};
      return map && typeof map === 'object' && !Array.isArray(map) ? map : {};
    } catch (err) {
      return mdvWishPinsMem;
    }
  }

  function mdvWishSavePins(map) {
    mdvWishPinsMem = map;
    try { window.localStorage.setItem('mdvWishAdded', JSON.stringify(map)); } catch (err) {}
  }

  function mdvWishPin(productId) {
    if (productId === undefined || productId === null || productId === '') { return; }
    var map = mdvWishPins();
    map[String(productId)] = Date.now();
    mdvWishSavePins(map);
  }

  function mdvWishUnpin(productId) {
    var map = mdvWishPins();
    if (Object.prototype.hasOwnProperty.call(map, String(productId))) {
      delete map[String(productId)];
      mdvWishSavePins(map);
    }
  }

  function mdvWishRemember(customerId, categories) {
    if (!customerId || String(customerId) !== String(ajaxcustomer_id) || !Array.isArray(categories)) { return; }
    mdvWishSnap = { customer: String(customerId), categories: categories };
    var present = {};
    categories.forEach(function (c) {
      (c && Array.isArray(c.products) ? c.products : []).forEach(function (p) { if (p) { present[String(p.shopify_product_id)] = 1; } });
    });
    var map = mdvWishPins(), now = Date.now(), changed = false;
    Object.keys(map).forEach(function (k) {
      // prune to the snapshot; an add still in flight keeps its pin for 30 s
      if (!present[k] && !(now - Number(map[k]) < 30000)) { delete map[k]; changed = true; }
    });
    if (changed) { mdvWishSavePins(map); }
  }

  function mdvWishSnapFor(customerId) {
    return mdvWishSnap && customerId && mdvWishSnap.customer === String(customerId) ? mdvWishSnap.categories : null;
  }

  function mdvWishLoad(customerId) { // one get-wishlist read; rejects if the wishlist cannot be read
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = customerId;
    let params1 = new URLSearchParams(wsGetWishlist);
    return fetch(`https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`)
      .then(function (response) {
        if (!response.ok) { throw new Error('Network response was not ok'); }
        return response.json();
      })
      .then(function (result) {
        // no data / no categories = the customer has no list yet ('Wishlist not found.')
        var categories = result && result.data && Array.isArray(result.data.categories) ? result.data.categories : [];
        mdvWishRemember(customerId, categories);
        return categories;
      });
  }

  function mdvWishIdsHolding(categories, productId) {
    var ids = [];
    (Array.isArray(categories) ? categories : []).forEach(function (c) {
      if (!c || !mdvWishIsId(c.id) || !Array.isArray(c.products)) { return; }
      var holds = c.products.some(function (p) { return p && String(p.shopify_product_id) === String(productId); });
      if (holds && ids.indexOf(c.id) === -1) { ids.push(c.id); }
    });
    return ids;
  }

  async function mdvWishListsHolding(productId, customerId) {
    var ids = mdvWishIdsHolding(mdvWishSnapFor(customerId), productId);
    if (!ids.length) { ids = mdvWishIdsHolding(await mdvWishLoad(customerId), productId); }
    return ids;
  }

  async function mdvWishAddTarget(customerId, customerName, customerEmail) {
    var lists = mdvWishSnapFor(customerId);
    if (!lists) { lists = await mdvWishLoad(customerId); }
    var id = mdvWishDefaultId(lists);
    if (id !== null) { return id; }
    if (lists.length) { return null; } // lists without a numeric id: send no category_id (server default)
    return await mdvWishCreateDefault(customerId, customerName, customerEmail);
  }

  function mdvWishCreateDefault(customerId, customerName, customerEmail) {
    if (mdvWishCreating && mdvWishCreating.customer === String(customerId)) { return mdvWishCreating.promise; }
    var wsCreate = {};
    wsCreate.store_name = window.wsapps.store_name;
    wsCreate.customer_id = customerId;
    wsCreate.customer_name = customerName;
    wsCreate.customer_email = customerEmail;
    wsCreate.category_name = 'FAVOURITE';
    var promise = fetch('https://wishlistapp.manieredevoir.com/api/category', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(wsCreate)
    })
      .then(function (response) {
        if (!response.ok) { throw new Error('Network response was not ok.'); }
        return response.json();
      })
      .then(function (result) {
        var id = result && result.error !== true && result.data ? result.data.id : null;
        if (!mdvWishIsId(id)) { throw new Error('mdvWishFlat-1: the FAVOURITE list was not created'); }
        mdvWishRemember(customerId, [{ id: id, category_name: result.data.category_name || 'FAVOURITE', products: [] }]);
        return id;
      })
      .catch(function (error) {
        console.log('error', error);
        mdvWishCreating = null;
        return null; // the add then goes without category_id and the server uses its own default list, as before
      });
    mdvWishCreating = { customer: String(customerId), promise: promise };
    return promise;
  }

  function mdvWishForget(productId) { // after a successful remove-from-all
    mdvWishUnpin(productId);
    if (!mdvWishSnap) { return; }
    mdvWishSnap = { customer: mdvWishSnap.customer, categories: mdvWishSnap.categories.map(function (c) {
      if (!c || !Array.isArray(c.products)) { return c; }
      return Object.assign({}, c, { products: c.products.filter(function (p) { return !p || String(p.shopify_product_id) !== String(productId); }) });
    }) };
  }

  function btnClickAfterPopup(target, productHandle, data_id, variant_id, categary_id, customer_id, customer_name, customer_email) {
    //console.log('btnClickAfterPopup ====================================================== API');
    var wsGetWishlist = {};
    wsGetWishlist.store_name = window.wsapps.store_name;
    wsGetWishlist.customer_id = customer_id ? customer_id : ajaxcustomer_id;    
    let params1 = new URLSearchParams(wsGetWishlist);
    let url = `https://wishlistapp.manieredevoir.com/api/get-wishlist?${params1.toString()}`;  
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(async result => {
      var mdvPopupLists = []; // mdvWishFlat-1
      if (result && typeof result.data === 'object' && result.data !== null && Array.isArray(result.data.categories)) {
        var mainArray = result.data.categories;
        mdvPopupLists = mainArray;
        if (Array.isArray(mainArray) && mainArray.length > 0) {
          latestCategories = mdvWishDefaultId(mainArray); // mdvWishFlat-1: the default list is the lowest id (was the last list)
        }
      }
      // mdvWishFlat-1: no list yet -> create FAVOURITE first and add into it (on failure no category_id is sent
      // and the server uses its own default list, as before).
      if (!mdvPopupLists.length) {
        latestCategories = (await mdvWishCreateDefault(customer_id ? customer_id : ajaxcustomer_id, customer_name ? customer_name : ajaxcustomer_name, customer_email ? customer_email : ajaxcustomer_email)) || '';
      }
    
    
      var wsAdd = {};
      wsAdd.store_name = window.wsapps.store_name;    
      wsAdd.customer_id = customer_id ? customer_id : ajaxcustomer_id;
      wsAdd.customer_email = customer_email ? customer_email: ajaxcustomer_email; // mdvWishFlat-1: was swapped with name
      wsAdd.customer_name = customer_name ? customer_name: ajaxcustomer_name;      
      if(latestCategories){
        wsAdd.category_id = latestCategories;
      }
      wsAdd.product_id = data_id ? data_id : window.wsapps.product_id;
      wsAdd.variant_id = variant_id ? variant_id : window.wsapps.variant_id;    
      
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsAdd)
      };
      fetch('https://wishlistapp.manieredevoir.com/api/add-to-wishlist', requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {
          location.reload(true);
        })
        .catch(function(error) {
          console.log('error', error);
      });
    })
  }



  function CSWSPageDataHeader(isNot) {
    // console.log('CSWSPageDataHeader ======================================================');
    var customerId = window.wsapps && ajaxcustomer_id ? `data-cusID="${ajaxcustomer_id}"` : `onclick="location.href = '/account';"`;
    var CSWSPageDataHeader = `
    <div id="cs-page-header">
      <div class="csws-header">
        <div class="csws-header-title">
          <div class="button_back"><a href="/"></a><h4 class="csws-header-uname">`+ajaxcustomer_name+` Wishlist</h4></div>
        </div>
      </div>
      `;
    
    CSWSPageDataHeader += `</div>`;
    return CSWSPageDataHeader;
  }
  function emptyhtmlGrid(params) {
    //console.log('emptyhtmlGrid ======================================================');    
    var emptyhtml = `<div class="cs-wishlist-wrapper"><div class="productHandlesByCategory is-empty" data-name="FAVOURITE">`;
    // mdvWishFlat-1: no list name, list menu (Rename) or delete prompt in the empty state.
    emptyhtml += `<ul class="${window.wsapps.parentClass}"></ul>`;
    emptyhtml += `</div></div>`;
    return emptyhtml;
  }

  function CSWSPageDataInnerHeader(key, id, new_create, hasProduct, isNot, element){   
    // console.log('CSWSPageDataInnerHeader ====================================================== Disha 2', key);    
    var cs_cate_title = ''
    if(key){
      cs_cate_title = key;
    }else{
      cs_cate_title = '<input class="cs-new-list-title" id="cs-new-list-title" type="text" placeholder="Enter List Name"  required="required" maxlength="40">'      
      var createListButtons = document.querySelectorAll("#csws-create-list");
      if (createListButtons.length > 0) {
        createListButtons.forEach(function(button) {
          button.setAttribute('disabled', 'disabled');
        });
      }
    }
    var CSWSPageDataInnerHeaderInfo = `<div class="cs-list-header-title"><h4>`+cs_cate_title.toLowerCase()+`</h4>
      <div class="cs-dropdown cs-dropdown-options 0000">
          <button class="cs-dropdown-toggle" id="cs-dropdown-toggle">
              `+window.wsapps.dots+`
          </button>
          <ul class="cs-dropdown-menu-main" role="menu">
              ${new_create === 'new_create' || new_create === 'empty_create' && !isNot ? `` : `<li class="cs-dropdown-menu-action">
                <button class="cs-dropdown-menu-btn category-edit" aria-label="Rename" data-val="${id}">Rename</button>
            </li>`}
              ${isNot ? `` : `<li class="cs-dropdown-menu">
                  <button class="cs-dropdown-menu-btn category-destroy" aria-label="Delete" data-val="${id}">Delete</button>
              </li>`}
          </ul>
        </div>
      </div>`;
    if(new_create){      
      if(element){
        var csWishlistWrappers = document.querySelectorAll('.cart_tab2 .cs-wishlist-wrapper');  
      }else{
        var csWishlistWrappers = document.querySelectorAll('.main-wrapper .cs-wishlist-wrapper');  
      }
      csWishlistWrappers.forEach(function(csWishlistWrapper) {
        var newDiv = document.createElement('div');
        newDiv.className = 'productHandlesByCategory ';
        newDiv.setAttribute('data-name', 'newCategory');
        newDiv.innerHTML = CSWSPageDataInnerHeaderInfo + `<ul class="${window.wsapps.parentClass}"></ul>` + removeContent();
        csWishlistWrapper.insertAdjacentElement('afterbegin', newDiv);
      });      
    }
    return CSWSPageDataInnerHeaderInfo;
  }


  function removeContent() {
    //console.log('removeContent ======================================================');
    var removeContent = `<div class="cs-list-delete-modal" style="display: none;">
              <div class="cs-delete-title">Delete this list?</div>
              <div class="cs-delete-btn">
                  <button class="cs-btn-cancel">Cancel</button>
                  <button class="cs-btn-delete">Delete</button>
              </div>
          </div>`;
    return removeContent;
  }

  
  // Set Page Wishlist
  function CSWishlistPageData(result, productList){   
    //console.log('CSWishlistPageData ====================================================== Disha 1');    
    var wishlists = result.data.categories;
    if (Array.isArray(wishlists) && wishlists.length){      
      var html = CSWSPageDataHeader(true);
    }else{
      var html = CSWSPageDataHeader();
      html += emptyhtmlGrid();
    }
    // $('.cs-wishlist-wrapper').remove();
    if(wishlists.length > 0) {
      // mdvWishFlat-1: one wishlist - ONE block (the default list's id and name, so the existing handlers still
      // resolve a list) holding every list's products, newest first, one card per product. No list name, list
      // menu, View All, delete prompt, Add list, or dragging between lists ('dropzone').
      var mdvFlatPage = mdvWishFlatten(wishlists);
      html += `<div class="cs-wishlist-wrapper">`;
      [mdvFlatPage.category || wishlists[0]].forEach(category => {
        html += `<div class="productHandlesByCategory productHandlesByCategory-${category.id} category-id-${category.category_name} ${mdvFlatPage.products.length == 0 ? 'is-empty' : ''}" data-name="${category.category_name}" id="category-id-${category.category_name.replace(/\s/g, '')}" data-cat-id="${category.id}">`;
        html += `<div class="${window.wsapps.parentClass}">`;
        // Create category title
        const title = document.createElement('h2');
        title.textContent = category.category_name;
        // Create a list for products
        var mdvSeenPage = {}; // mdvWishGrid-1 W3 (no 6-item cap) + W6 (one card per product per list)
        mdvFlatPage.products.forEach(product => {
          if (mdvWishSeen(mdvSeenPage, product)) { return; }
          // mdvWishIds-1: the card star also carries class mdv-ws-fav-btn (id ws-fav-btn unchanged)
          html += `
          <div draggable="true" data-pro-id="${product.shopify_product_id}" data-varId="${product.variants.shopify_variant_id}" class="ws-pro-list-image main-product-item" data-handle="${product.handle}">
            <div class="main-product-wrp">
              <a href="/pages/${window.wsapps.pageURL}?from_user_id=${ajaxcustomer_id}&list_id=${category.id}" data-href="${product.image_url}" class="main-product-inner" draggable="false"> 
                <img src="${product.image_url}" alt="${product.title}" loading="lazy" data-pro-name="${product.title}" />
              </a>
              <div class="cs_ws_icon" data-id="${product.shopify_product_id}" data-handle="${product.handle}" data-varId="${product.shopify_product_id}">
                <button aria-label="Add to Wishlist" id="ws-fav-btn" type="button" class="action_button  ws-active mdv-ws-fav-btn"><span class="cs-wishlist-icon"><svg width="25" height="21" viewBox="0 0 23 21" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M11.5801 0.992188L14.668 7.2511L21.5801 8.2606L16.5801 13.13L17.7678 20.0183L11.5801 16.7642L5.39243 20.0183L6.58008 13.13L1.58008 8.2606L8.49219 7.2511L11.5801 0.992188Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></button>
              </div>
            </div>  
          </div>`
        });
        html += `</div>`;
        html += `</div>`;
      });
      html += `</div>`;
    }
    html += `<div class="sign-out link_btn"><a href='/account/logout'>Log out</a></div>`;
    var wishlistHTML = document.querySelectorAll('.main-wrapper .CS-Wishlist-page');
    if(wishlistHTML.length > 0){
      for (var i = 0; i < wishlistHTML.length; i++) {
        wishlistHTML[i].classList.add("wishlist-overflow");
        wishlistHTML[i].innerHTML = '';  
        wishlistHTML[i].innerHTML += html;
      }
    }
  } 

  // Set Page Drawer Data
  function CSWishlistDrawerData(result, productList){   
    //console.log('CSWishlistDrawerData ====================================================== Disha 2');
    var wishlists = result.data.categories;
    if (Array.isArray(wishlists) && wishlists.length){      
      var html = CSWSPageDataHeader(true);
    }else{
      
      var html = CSWSPageDataHeader();
      html += emptyhtmlGrid();
    }
    
    // $('.cs-wishlist-wrapper').remove();
    if(wishlists.length > 0) {
      // mdvWishFlat-1: one wishlist - ONE block (the default list's id and name) holding every list's products,
      // newest first, one card per product. No list name, list menu, chooser tile, View All, delete prompt or
      // Add list.
      var mdvFlatDrawer = mdvWishFlatten(wishlists);
      html += `<div class="cs-wishlist-wrapper">`;
      [mdvFlatDrawer.category || wishlists[0]].forEach(category => {
        html += `<div class="productHandlesByCategory productHandlesByCategory-${category.id} category-id-${category.category_name} ${mdvFlatDrawer.products.length == 0 ? 'is-empty' : ''}" data-name="${category.category_name}" id="category-id-${category.category_name.replace(/\s/g, '')}" data-cat-id="${category.id}">`;
        html += `<div class="${window.wsapps.parentClass}">`;
        // Create category title
        const title = document.createElement('h2');
        title.textContent = category.category_name;
        
        // Create a list for products
        var mdvSeenDrawer = {}; // mdvWishGrid-1 W6: one card per product per list
        mdvFlatDrawer.products.forEach((product, index) => {
          if (mdvWishSeen(mdvSeenDrawer, product)) { return; }
          // mdvWishIds-1: the card star also carries class mdv-ws-fav-btn (id ws-fav-btn unchanged)
          html += `
          <div class="ws-pro-list-image ${product.handle}" data-loop="${index}">
            <div class="cross-sell-product-item-page cross-sell-product-item cross-sell-item main-product-item two_column_item" data-handle="${product.handle}" data-id="${product.shopify_product_id}">
              <div class="cross-sell-product-image">
                <a href="/products/${product.handle}">
                  <img src="${product.image_url}" alt="${product.title}" loading="lazy">
                </a>
              </div>
              <div class="cross-sell-product-content">
                <div class="cross-sell-product-price">      
                  <div class="cs-product-title">
                    <a href="/products/${product.handle}">${product.title}</a>
                  </div>
                  <div class="cs_ws_icon" data-id="${product.shopify_product_id}" data-handle="${product.handle}" data-varId="${product.shopify_product_id}">
                    <button aria-label="Add to Wishlist" id="ws-fav-btn" type="button" class="action_button  ws-active mdv-ws-fav-btn"><span class="cs-wishlist-icon"><svg width="25" height="21" viewBox="0 0 23 21" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M11.5801 0.992188L14.668 7.2511L21.5801 8.2606L16.5801 13.13L17.7678 20.0183L11.5801 16.7642L5.39243 20.0183L6.58008 13.13L1.58008 8.2606L8.49219 7.2511L11.5801 0.992188Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></button>
                  </div>                  
                </div>
              </div>
            </div>
          </div>`
        });
        html += `</div>`;
        html += `</div>`;
      });
      html += `</div>`;
    }
    html += `<div class="sign-out link_btn"><a href='/account/logout'>Log out</a></div>`;
    
    var wishlistHTML = document.querySelectorAll('.CS-drawer-wishlist');
    $('.productHandlesByCategory[data-name="newCategory"]:not(.is-empty)').remove();
    if(wishlistHTML.length > 0){
      for (var i = 0; i < wishlistHTML.length; i++) {
        wishlistHTML[i].classList.add("wishlist-overflow");
        wishlistHTML[i].innerHTML = '';  
        wishlistHTML[i].innerHTML += html;
      }
    }  
    if(location.pathname.includes('/collections/')){ 
      wishlistBtnCollection(productList); 
    }
    if(location.pathname.includes('/products/')){ 
      wishlistBtnPDP(productList);
    }
    formData();
  } 

  async function formData() {
    //console.log('formData ======================================================')
    document.querySelectorAll('.cross-sell-product-item').forEach(async (item) => {      
      var productHandle = item.getAttribute('data-handle');
      if(productHandle){
        var addpendHTML = await getproHTML(`/products/${productHandle}?view=ws-pro-list-new`);

        if (!addpendHTML) {
          item.style.display = 'none';
          document.querySelector(`.min-cart-inner .ws-pro-list-image .cross-sell-product-item[data-handle="${productHandle}"]`)?.parentElement?.style.setProperty("display", "none");
          document.querySelector(`.ws-pro-list-image.main-product-item[data-handle="${productHandle}"]`)?.remove();
          document.querySelector(`.ws-pro-list-image.${productHandle}`)?.style.setProperty('display', 'none');
          return;
        }

        if (addpendHTML.includes('fetch-template')) {
          if (!addpendHTML.trim() || addpendHTML.includes('Page Not Found')) {
            item.style.display = 'none';
            document.querySelector(`.ws-pro-list-image.main-product-item[data-handle="${productHandle}"]`)?.remove();
            document.querySelector(`.ws-pro-list-image.${productHandle}`)?.style.setProperty('display', 'none');
            return;
          }else {
            item.querySelector('#product_add')?.remove();
            item.querySelector('.cross-sell-product-price.fetch-template')?.remove();
            item.querySelector('.cross-sell-product-price')?.insertAdjacentHTML('afterend', addpendHTML);
          }
        }
      }
    });
  }
  
  document.addEventListener("click", function(e){ 
    updateSizeForAU('.cart-recommended-option-ul li');
    document.querySelectorAll('.cs-dropdown-menu-main, .cs-dropdown-menu-mai').forEach((item) => {
      item.classList.remove('active');  
    })
    // Show toggle
    var csDropdownToggle = e.target.closest('.cs-dropdown-toggle'); // Or any other selector.    
    if(csDropdownToggle){
      var dropdownMenu = csDropdownToggle.parentElement.querySelector('.cs-dropdown-menu-main');
      if (dropdownMenu) {
        dropdownMenu.classList.toggle('active');
      }
    }


    // Click Category Destroy 
    // var categoryDestroyButtons = e.target.closest(".category-destroy");
    // if(categoryDestroyButtons){      
    //   categoryDestroyButtons.closest('.productHandlesByCategory').querySelector('.product-grid').style.display = 'none';     
    //   categoryDestroyButtons.closest('.productHandlesByCategory').querySelector('.cs-list-delete-modal').style.display = 'block';
      
    // }
    
    // // Click Cancel Btn
    // var categoryDestroyCancelButtons = e.target.closest('.cs-btn-cancel');
    // if(categoryDestroyCancelButtons){      
    //   categoryDestroyCancelButtons.closest('.productHandlesByCategory').querySelector('.cs-list-delete-modal').style.display = 'none';
    //   categoryDestroyCancelButtons.closest('.productHandlesByCategory').querySelector('.product-grid').style.display = 'flex';
    // }

    // mdvWishFlat-1: one wishlist per customer - the list Delete (.category-destroy) handler is removed.

    // Click Category Edit
    // var categoryEditButtons = e.target.closest('.category-edit');
    // if(categoryEditButtons){      
    //   var closestProductHandles = categoryEditButtons.closest('.productHandlesByCategory');        
    //   if (closestProductHandles) {
    //     var dataCategoryName = closestProductHandles.getAttribute('data-name');
    //     var dataCategoryID = closestProductHandles.getAttribute('data-cat-id');
    //     var cs_cate_title = '<input class="cs-edit-list-title" id="cs-edit-list-title" type="text" placeholder="List name"  required="required" maxlength="40" data-cat-id="'+dataCategoryID+'" value="'+dataCategoryName+'">';
    //     closestProductHandles.querySelector('h2').innerHTML = cs_cate_title;    
        
    //   }
    // }
    // var csEditListTitle = e.target.closest('#cs-edit-list-title');
    // if(csEditListTitle){        
    //   var dataCategoryID = csEditListTitle.getAttribute('data-cat-id');
    //   csEditListTitle.addEventListener('blur', function(event) {       
    //     dataCategoryID !== 'null' ? updateCategoryName(event.target.value, dataCategoryID) : createCategory(event.target.value);
    //   });
    // }
    // mdvWishFlat-1: the list Rename (.category-edit) handler is removed.


    
    // Hide productHandlesByCategory content
    var listHeaderDropdowns  = e.target.closest('.list-header-dropdown'); // Or any other selector.    
    if (listHeaderDropdowns) {
      var closestProductHandles = listHeaderDropdowns.closest('.productHandlesByCategory');
      if (closestProductHandles) {
        closestProductHandles.classList.toggle('productHandlesByCategory_hide');
      }
    }
      


    // Add in Wishlist Collection and Product page
    var target = e.target.closest('#'+wsBtnID) || e.target.closest(addToWishlistCollection) ; // Or any other selector.    
    if (target) {
      var abcParentDiv = target.closest('.CS-Wishlist-page');
      var productHandle = target.getAttribute('data-handle'); 
      var data_id = target.getAttribute('data-id'); 
      var variant_id = target.getAttribute('data-varId'); 
      var category_id = target.getAttribute('data-categoryId');
      var parentElement = target.parentElement;
      var productElement = target.closest('.productHandlesByCategory');      
      if (productElement &&  productElement.getAttribute('data-cat-id')) {
        category_id = productElement.getAttribute('data-cat-id');        
      }
      if(ajaxcustomer_id){
        if (abcParentDiv) { 
          target.closest('.cross-sell-product-item') ? e.target.closest('.cross-sell-product-item').classList.add("delete_hide") : '';
          target.closest('.ws-pro-list-image') ? e.target.closest('.ws-pro-list-image').remove() : '';
          btnClick(target, productHandle, data_id, variant_id, category_id, 'remove');
        }else{
          if (target.querySelector('#ws-fav-btn').classList.contains('ws-active')) {
            btnClick(target, productHandle, data_id, variant_id, category_id, 'remove');
            target.querySelector('#ws-fav-btn').classList.remove('ws-active');
            target.querySelector('.cs-wishlist-icon').innerHTML = icon;
          } else {
            categoryGetList(target, productHandle, data_id, variant_id, category_id)
          }
        }
      }else{
        if(window.wsapps.customerLogin){
          window.location.href = window.wsapps.urlLogin;
        } else {
          var wishlistPopup = document.querySelector('body > .wishlist-popup');
          if (wishlistPopup) {
            wishlistPopup.classList.add('active');     
            loginPopupFunction(target, productHandle, data_id, variant_id, category_id)
            registerPopupFunction(target, productHandle, data_id, variant_id, category_id)
            
          }
        }
      }
    }
    //Click on Add a new list


    // mdvWishFlat-1: the Add list (#csws-create-list) handler is removed.

    // var csNewListTitle = e.target.closest('#cs-new-list-title'); 
    // if(csNewListTitle){
    //   csNewListTitle.addEventListener('blur', function(event) {          
    //     var inputValue = event.target.value.trim();
    //     if (inputValue !== '') {
    //       //console.log('createCategory ============================= 2');
    //       createCategory(event.target.value)
    //     }else{
    //       event.target.value = '';
    //       CSUpdateUI(null, null, 'newCreate');
    //     }        
    //   });
    // }
  });


  // mdvWishFlat-1: the new-list name (#cs-new-list-title) focusout handler, which created a list, is removed.

  
  
// Change Category Product
  function changeCategoryPro(category_id, product_id, variant_id){
    var wsAdd = {};
    wsAdd.store_name = window.wsapps.store_name;
    wsAdd.customer_id = ajaxcustomer_id;
    wsAdd.customer_name = ajaxcustomer_name;
    wsAdd.customer_email = ajaxcustomer_email;
    wsAdd.category_id = category_id,
    wsAdd.product_id = product_id;
    wsAdd.variant_id = variant_id;
    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(wsAdd)
    };
    fetch('https://wishlistapp.manieredevoir.com/api/add-to-wishlist', requestOptions)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        return response.json();
      })
      .then(function(result) {        
      })
      .catch(function(error) {
        console.log('error', error);
    });
  }
  
  // Category Destroy Function
  function removeCategory(dataCategoryID){   
    //console.log('removeCategory ====================================================== API', dataCategoryID);
    //console.log('dataCategoryID ===', dataCategoryID)
    if(dataCategoryID){
      var wsRemove = {};
      wsRemove.store_name = window.wsapps.store_name;    
      var requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsRemove)
      };       
      fetch('https://wishlistapp.manieredevoir.com/api/category/'+dataCategoryID, requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {
          var elementsToRemove = document.querySelectorAll('.productHandlesByCategory-' + dataCategoryID);
          elementsToRemove.forEach(function(element) {
            element.parentNode.removeChild(element);
          });

          var CSWishlistPage = document.getElementById("CS-Wishlist-page");
          if(CSWishlistPage){
            CSWishlistPage.innerHTML = '<div class="EmptyPageData"><img src="https://cdn.shopify.com/s/files/1/0282/6678/files/Eiffel-Simultaneous.gif?v=1689851940" /></div>';
          }
          
          CSUpdateUI(null, null, 'newCreate')
        })
        .catch(function(error) {
          console.log('error', error);
      });
    }else{
      document.getElementById("csws-create-list").removeAttribute('disabled', 'disabled');
      var productHandles = document.querySelector('.productHandlesByCategory.is-empty[data-name="newCategory"]');      
      if (productHandles) {
          productHandles.style.display = 'none';
      }      
    }
  }

  // Update categories Name
  function updateCategoryName(createCategoryName, createCategoryId){
    //console.log('updateCategoryName ====================================================== API');
    if(createCategoryName && createCategoryId ){
      var wsAdd = {};
      wsAdd.store_name = window.wsapps.store_name;        
      wsAdd.category_name = createCategoryName;
      var requestOptions = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsAdd)
      }; 
      fetch('https://wishlistapp.manieredevoir.com/api/category/'+createCategoryId, requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {            
          var csEditListTitle = document.getElementById('cs-edit-list-title');
          if (csEditListTitle) {
            csEditListTitle.closest('.productHandlesByCategory').classList.add('productHandlesByCategory-'+result.data.id)
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-name', result.data.category_name);              
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-cat-id', result.data.id);              
            csEditListTitle.closest('h4').innerHTML = result.data.category_name;
          } 
          setLoader();
          CSUpdateUI(null, null, 'newCreate');
        })
        .catch(function(error) {
          console.log('error', error);
      });
    }
  }
  
  // Create new categories 
  function createCategory(createCategoryName){
    //console.log('createCategory ====================================================== API');
    if(createCategoryName){
      var wsAdd = {};
      wsAdd.store_name = window.wsapps.store_name;      
      wsAdd.customer_id = ajaxcustomer_id;
      wsAdd.category_name = createCategoryName;
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wsAdd)
      };        
      fetch('https://wishlistapp.manieredevoir.com/api/category', requestOptions)
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Network response was not ok.');
          }
          return response.json();
        })
        .then(function(result) {
          var csEditListTitle = document.getElementById('cs-new-list-title');
          if (csEditListTitle) {
            csEditListTitle.closest('.productHandlesByCategory').classList.add('productHandlesByCategory-'+result.data.id)
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-name', result.data.category_name);              
            csEditListTitle.closest('.productHandlesByCategory').setAttribute('data-cat-id', result.data.id);              
            csEditListTitle.closest('h4').innerHTML = result.data.category_name;
          }
          var createListButtons = document.querySelectorAll("#csws-create-list");
          if (createListButtons.length > 0) {
            createListButtons.forEach(function(button) {
              button.removeAttribute('disabled');
            });
          }
          setLoader()          
          CSUpdateUI(null, null, 'newCreate')
        })
        .catch(function(error) {
          console.log('error', error);
      });
    }
  }





  
  // Drag functionality
  (function() {
    var dragged = null, positions = [];
    function getObject(parentId, html, index, elementID){
       let item = {
        parentId: parentId,
        html: html,
        position: index,
        currentID: elementID
      };
      return item;
    }
    document.addEventListener("dragstart", (event) => {
      return dragged = event.target;
    });

    document.addEventListener("dragend", (event) => {        
    });

    document.addEventListener("dragover", function(event) {
      return event.preventDefault();
    });

    document.addEventListener("drop", (event) => {
      event.preventDefault();
      let draggedParent = dragged.closest(".product-grid");
      if (event.target.closest('.productHandlesByCategory').classList.contains("dropzone")) {
        var getParentDiv = event.target.closest('.productHandlesByCategory').querySelector('.product-grid');
        dragged.closest(".product-grid").removeChild(dragged);
        draggedParent.children.length == 0 ? draggedParent.closest('.productHandlesByCategory').classList.add('is-empty') : draggedParent.closest('.productHandlesByCategory').classList.remove('is-empty');
        getParentDiv.appendChild(dragged);
        getParentDiv.children.length == 0 ? getParentDiv.closest('.productHandlesByCategory').classList.add('is-empty') : getParentDiv.closest('.productHandlesByCategory').classList.remove('is-empty');          
        var dataProId = dragged.getAttribute('data-pro-id');
        var dataProVarId = dragged.getAttribute('data-varid');
        var dataCatId = event.target.closest(".productHandlesByCategory").getAttribute('data-cat-id');    
        changeCategoryPro(dataCatId, dataProId, dataProVarId);
      }
    });    
  }).call(this);


  // Login form submission
  var formSubmitting = false;
  function loginPopupFunction(target, productHandle, data_id, variant_id, category_id) {
    //console.log('loginPopupFunction ======================================================');
    $('body > .wishlist-popup #main-login-drawer.wishlist-popup-form > #customer_login').off('submit').on("submit", function(e) {      
      $('div#main-login-drawer .error_info').remove();
      e.preventDefault();      
      if (!formSubmitting) {          
        $.ajax({
          url: '/account/login',
          method: 'post',
          data: $(this).serialize(),
          dataType: 'html',
          async: true,
        }).done(function(response){
          if(response.indexOf('Incorrect email or password.') !== -1){
            $('div#main-login-drawer').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');   
            formSubmitting = false;
          }else{
            formSubmitting = true;
            if(variant_id){          
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = response;
              var customer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
              ajaxcustomer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
              
              var customer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
              ajaxcustomer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
              
              var customer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');
              ajaxcustomer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');

              console.log('11 =================');
              CSRetrieveWishlistData('drawer', customer_id, customer_name)
              categoryGetList(target, productHandle, data_id, variant_id, category_id, customer_id, customer_name, customer_email)              
            }else{
              location.reload(true);
            }
            $('.wishlist-popup').removeClass('active');    
          }
        });
      }
    });
  }


  $('.cart_tab2 > .wishlist-popup #main-login-drawer.wishlist-popup-form > #customer_login, body.template-main-cs-wishlist .main-wrapper #tab1 > #customer_login').on( "submit", function( e ) {    
    $('div#main-login-drawer .error_info').remove();    
    e.preventDefault();    
    $.ajax({
      url: '/account/login',
      method: 'post',
      data: $(this).serialize(),
      dataType: 'html',
      async: true,
    }).done(function(response){
      $('.error_info').remove();
      if(response.indexOf('Incorrect email or password.') !== -1){
        $('div#main-login-drawer, body.template-main-cs-wishlist .main-wrapper #tab1').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');       
      }else{
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = response;
        var customer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
        ajaxcustomer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
        ajaxcustomer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
        ajaxcustomer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');
        //console.log('12 =================');
        CSRetrieveWishlistData('drawer', customer_id);
        document.querySelector('.wishlist-popup').classList.remove('active');
        document.querySelector('.cart_tab2 #CS-Wishlist-page').style.display = 'flex';
        if(location.pathname.includes(pageUrl)){
          location.reload(true);
        }
      }
    });
  });


  // Registration form submission
  var registerFormSubmitting = false;
  function registerPopupFunction(target, productHandle, data_id, variant_id, category_id) {
    //console.log('registerPopupFunction ======================================================');    
    $('body > .wishlist-popup #register_form.wishlist-popup-form > #create_customer_model').on( "submit", function( e ) {
      $('div#register_form .error_info').remove();
      e.preventDefault();  
       if (!registerFormSubmitting) { 
        $.ajax({
          url: '/account',
          method: 'post',
          data: $(this).serialize(),
          dataType: 'html',
          async: true,
        }).done(function(response){  
          registerFormSubmitting = false;
          if(response.indexOf('Email is invalid') !== -1 || response.indexOf('Email can&#39;t be blank') !== -1 || response.indexOf('Password can&#39;t be blank.') !== -1 ){      
            $('div#register_form').prepend('<ul class="error_info"><li>Password can&#39;t be blank.</li><li>Email can&#39;t be blank.</li></ul>');    
          }else if(response.indexOf('Email is invalid') !== -1 ){      
            $('div#register_form').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');       
          } else if(response.indexOf('This email address is already associated with an account. If this account is yours, you can') !== -1){
            $('div#register_form').prepend('<p class="error_info">This email address is already associated with an account. If this account is yours, you can <a href="/account/login#recover">reset your password</a></p>');       
          } else{
            registerFormSubmitting = true;
            if(variant_id){          
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = response;
              var customer_id = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerId');
              var customer_name = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customerName');
              var customer_email = tempDiv.querySelector('.wishlist-popup.login').getAttribute('data-customeremailId');
              
              btnClickAfterPopup(target, productHandle, data_id, variant_id, category_id, customer_id, customer_name, customer_email);
            }else{
              location.reload(true);
            }
            $('.wishlist-popup').removeClass('active');    
          }
        });
      }
    });
  }
  
  //registerPopupFunction()
  $('.cart_tab2 > .wishlist-popup #register_form.wishlist-popup-form > #create_customer_model, body.template-main-cs-wishlist .main-wrapper #tab2 > #create_customer_model').on( "submit", function( e ) {
      $('div#register_form .error_info').remove();
      e.preventDefault();    
      $.ajax({
        url: '/account',
        method: 'post',
        data: $(this).serialize(),
        dataType: 'html',
        async: true,
      }).done(function(response){    
        //console.log('response =', response)
        $('.error_info').remove();
        if(response.indexOf('Email is invalid') !== -1 || response.indexOf('Email can&#39;t be blank') !== -1 || response.indexOf('Password can&#39;t be blank.') !== -1 ){      
          $('div#register_form, body.template-main-cs-wishlist .main-wrapper #tab2').prepend('<ul class="error_info"><li>Password can&#39;t be blank.</li><li>Email can&#39;t be blank.</li></ul>');    
        }else if(response.indexOf('Email is invalid') !== -1 ){      
          $('div#register_form, body.template-main-cs-wishlist .main-wrapper #tab2').prepend('<p class="error_info text-unset">Incorrect Email or Password.</p>');       
        } else if(response.indexOf('This email address is already associated with an account. If this account is yours, you can') !== -1){
          $('div#register_form, body.template-main-cs-wishlist .main-wrapper #tab2').prepend('<p class="error_info">This email address is already associated with an account. If this account is yours, you can <a href="/account/login#recover">reset your password</a></p>');       
        } else{
          
          location.reload(true);
          
          $('.wishlist-popup').removeClass('active');    
        }
      });
  });
    
  
}
/// Disha Hetre



/* --------------- Register button Click Start For Popup ---------------*/
function registerClick(registerLink, mainpopup) {
  if (registerLink) {
    registerLink.addEventListener('click', function() {      
      //console.log('registerClick ======================================================');
      var checkGenderSetValue = $('body > .wishlist-popup ul.checkGender-option li.activeFinal').text();
      $('.checkGender').find('.checkGender-value').val(checkGenderSetValue);
      if(mainpopup){
        var loginPopup = document.querySelector('body > .wishlist-popup.login');
        var registerPopup = document.querySelector('body > .wishlist-popup.register');
      }else{
        var loginPopup = document.querySelector('.wishlist-popup.login');
        var registerPopup = document.querySelector('.wishlist-popup.register');
      }
      if (loginPopup) {
        loginPopup.classList.remove('active');
      }
      if (registerPopup) {
        registerPopup.classList.add('active');
      }
    });
  } 
}
var registerLink1 = document.querySelector('.popup-register-link.register-popup#instance1');
var registerLink2 = document.querySelector('.popup-register-link.register-popup#instance2');
if(registerLink1){ registerClick(registerLink1, 'mainpopup') } 
if(registerLink2){ registerClick(registerLink2) }
/* --------------- Register button Click End For Popup ---------------*/

/* --------------- Login button Click Start For Popup ---------------*/
function loginClick(loginLink, mainpopup) { 
  if (loginLink) {
    loginLink.addEventListener('click', function() {
      //console.log('Login Click ======================================================');
      if(mainpopup){
        var loginPopup = document.querySelector('body > .wishlist-popup.login');
        var registerPopup = document.querySelector('body > .wishlist-popup.register');
      }else{
        var loginPopup = document.querySelector('.wishlist-popup.login');
        var registerPopup = document.querySelector('.wishlist-popup.register');
      }
      if (loginPopup) {
        loginPopup.classList.add('active');
      }
      if (registerPopup) {
        registerPopup.classList.remove('active');
      }
    });
  }       
}
var loginLink1 = document.querySelector('.popup-register-link.login-popup#instance1');
var loginLink2 = document.querySelector('.popup-register-link.login-popup#instance2');
if(loginLink1){ loginClick(loginLink1, 'mainpopup') } 
if(loginLink2){ loginClick(loginLink2) }
/* --------------- Login button Click End For Popup ---------------*/


function closePopup() {
  //console.log('closePopup ======================================================');
  $('body > .wishlist-popup').removeClass('active');  
  $('.wishlist-popup-form').find('form').find("input[type=email], input[type=text], input[type=password], textarea").val("");
}
$('body').on('click','.wishlist-popup-close', function(e){
  //console.log('wishlist-popup-close ======================================================');
  e.preventDefault();
  closePopup();
});
$(document).keyup(function(e) {
  if (e.keyCode == 27) { 
    closePopup();
  }
});
window.onclick = function(e) {
  if ($(e.target).hasClass('main-overlay')) {
    // console.log('closePopup ======================================================');
    closePopup();
  }
}



function CSWishlistrefreshData(drawer){  
  //console.log('CSWishlistrefreshData ======================================================');
  if(window.wsapps.wishlist_status == '1') {
    if(ajaxcustomer_id){
      if(drawer){
        //console.log('13 =================');
        CSRetrieveWishlistData('drawer');  
      }else{
        if(!(location.pathname.includes(pageUrl))){
          const element = document.querySelector('.cart_tab_link2');          
          if (location.pathname.includes('/collections/') || element && element.classList.contains('active')) {
            //console.log('14 =================');
            CSRetrieveWishlistData();
          }
        }
      }
    }else{
      if(location.pathname.includes('/products/')){ 
        wishlistBtnPDP()
      }
      if(location.pathname.includes('/collections/')){ 
        wishlistBtnCollection()
      }
      emptyPage();
    }
  }
}
$(document).ready(function(){

    $(document).on("click","#CS-Wishlist-page .cross-sell-product-item .select-option",function(e) {
      e.preventDefault();
      $('.check-stock-msg ').removeClass('active');
      $('#CS-Wishlist-page .cross-sell-product-item .variant-listbox').not($(this).parents('.variant-listbox')).removeClass("active");
      $(this).parents('.variant-listbox').toggleClass("active");
      $('#CS-Wishlist-page .cross-sell-product-item .cart-recommended-option-ul').not($(this).parents('.cross-sell-product-item').find('.cart-recommended-option-ul')).slideUp();
      if($(this).parents('.variant-listbox').hasClass("active")){
        $(this).parents('.cross-sell-product-item').find('.cart-recommended-option-ul').slideDown();
        // $(".min-cart-top").animate({ scrollTop: $('.min-cart-top').height() + $('.min-cart-main').height()}, 500);
      }else{
        $(this).parents('.cross-sell-product-item').find('.cart-recommended-option-ul').slideUp();
      }
    });

  $(document).on("click","#CS-Wishlist-page .cross-sell-product-item #variant-listbox ul li.variant-size",function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parents('.variant-listbox').removeClass("active");
    var current_variant = $(this).attr("value");
    $(this).parents("#CS-Wishlist-page .cross-sell-product-item").find("select#variant-listbox").val(current_variant).change();
    $(this).parents("#CS-Wishlist-page .cross-sell-product-item").find(".cross-sell-product-btn input").trigger("click");
    $('.cart_tab_link1').trigger('click')
  });

  $(document).on('click', function (event) {
    if (!$(event.target).closest('.variant-listbox').length) {
      $('#CS-Wishlist-page .cross-sell-product-item .variant-listbox').removeClass("active");
    }
  });
});


$(document).ready(function(){
   $('body').on('click','.cart_tab2 .productHandlesByCategory .scroll_product_drawer > div > a', function(e){
    e.preventDefault();
    var catId = $(this).attr('data-catId');    
    CSCategoryGetSingle(catId)
  })
})


